import {
  LOGIST_LINK_KIND_LABELS,
  type LogistMatchCandidate,
} from '@entities/logistics';
import {
  SubCard,
  SubSectionTitle,
  InlineBtn,
  SubCardSubtitle,
  Table,
  Th,
  Td,
  Badge,
  ReasonCell,
  SmallBtn,
} from './styles';

interface LogistMatchCandidatesCardProps {
  matchFor: string;
  matchCands: LogistMatchCandidate[];
  onClose: () => void;
  onLink: (inboxId: string, candidate: LogistMatchCandidate) => void;
}

export function LogistMatchCandidatesCard({
  matchFor,
  matchCands,
  onClose,
  onLink,
}: LogistMatchCandidatesCardProps) {
  if (matchCands.length === 0) return null;

  return (
    <SubCard>
      <SubSectionTitle>
        Кандидаты для связки{' '}
        <InlineBtn onClick={onClose}>
          Закрыть
        </InlineBtn>
      </SubSectionTitle>
      <SubCardSubtitle $marginBottom={8}>
        Сильного однозначного совпадения не найдено — выберите вручную. Балл — уверенность
        детерминированного подбора (№ накладной, масса, дата, наименование).
      </SubCardSubtitle>
      <Table>
        <thead>
          <tr>
            <Th>Тип</Th>
            <Th>Документ</Th>
            <Th>Наименование</Th>
            <Th>Поставщик</Th>
            <Th>Балл</Th>
            <Th>Основание</Th>
            <Th>Действия</Th>
          </tr>
        </thead>
        <tbody>
          {matchCands.map((c) => (
            <tr key={`${c.kind}-${c.id}`}>
              <Td>{LOGIST_LINK_KIND_LABELS[c.kind] ?? c.kind}</Td>
              <Td>{c.doc_number ?? '—'}</Td>
              <Td>{c.nomenclature ?? '—'}</Td>
              <Td>{c.supplier ?? '—'}</Td>
              <Td>
                <Badge $tone={c.strong ? 'ok' : 'muted'}>{c.score.toFixed(2)}</Badge>
              </Td>
              <ReasonCell>{c.reason || '—'}</ReasonCell>
              <Td>
                <SmallBtn onClick={() => onLink(matchFor, c)}>Привязать</SmallBtn>
              </Td>
            </tr>
          ))}
        </tbody>
      </Table>
    </SubCard>
  );
}
